import { getElapsedHours } from '../utilities/DateHelpers';
import {
    roundToAtMost2Decimals,
    toNumberSafe,
} from '../utilities/NumberHelpers';
import _ from 'lodash-es';

export const getTimeDetails = (timesheetDetail) => {
    const {
        start,
        end,
        adjustedStart,
        adjustedEnd,
        timesheetDetailContractPhases,
        timesheetDetailContractPhaseAdjustments,
    } = timesheetDetail;

    const startAndEndSet = (start && end) || (adjustedStart && adjustedEnd);

    if (!startAndEndSet) {
        return {
            incomplete: true,
            hoursAvailable: 0,
            hoursWorked: 0,
            warning: true,
        };
    }

    const hoursAvailable = getElapsedHours(
        adjustedStart ?? start,
        adjustedEnd ?? end
    );

    const hoursWorked =
        _.sumBy(
            timesheetDetailContractPhases.filter(
                (tdcp) =>
                    !tdcp.clientAdjustment &&
                    !tdcp.timesheetDetailContractPhaseAdjustmentId
            ),
            (tdcp) => toNumberSafe(tdcp.quantity)
        ) +
        _.sumBy(timesheetDetailContractPhaseAdjustments, (tdcpa) =>
            toNumberSafe(tdcpa.quantity)
        );

    return {
        hoursAvailable: roundToAtMost2Decimals(hoursAvailable),
        hoursWorked: roundToAtMost2Decimals(hoursWorked),
        warning: roundToAtMost2Decimals(hoursAvailable - hoursWorked) != 0,
        hoursRemaining: roundToAtMost2Decimals(hoursAvailable - hoursWorked),
        incomplete: false,
    };
};
